import Cookies from 'js-cookie'

const TokenKey = 'Authorization'
/*
* 设置setLocalStorage
* */
export function setLocalStorage (key, value) {
  window.localStorage.setItem(key, window.JSON.stringify(value))
}
/*
* 获取getLocalStorage
* */
export function getLocalStorage (key) {
  return window.JSON.parse(window.localStorage.getItem(key))
}
/*
* 设置setlocalStorage
* */
export function setlocalStorage (key, value) {
  window.localStorage.setItem(key, window.JSON.stringify(value))
}
/*
* 获取getlocalStorage
* */
export function getlocalStorage (key) {
  return window.JSON.parse(window.localStorage.getItem(key) || '[]')
}
/*
* 获取getToken
* */
export function getToken () {
  return Cookies.get(TokenKey)
}
/*
* 设置setToken
* */
export function setToken (token) {
  return Cookies.set(TokenKey, token)
}
/*
* 移除removeToken
* */
export function removeToken () {
  return Cookies.remove(TokenKey)
}
/*
* 清除removeLocalStorage
* */
export function removeLocalStorage (key) {
  return window.localStorage.removeItem(key)
}




//////////////////
// WEBPACK FOOTER
// ./src/utils/auth.js
// module id = TIfe
// module chunks = 41